import React, { useState } from "react";
import cls from "./MflistExcelinput.module.css";
import { fmtPhone } from "../../../lib/mfBulkInput/rowUtils";

export default function BulkInputMessagePanel({
  message,
  setMessage,
  replyNumber,
  setReplyNumber,
  apiAddr,
}) {
  const [showTest, setShowTest] = useState(false);
  const [testTo, setTestTo] = useState("");
  const [testStatus, setTestStatus] = useState("idle");
  const [testMsg, setTestMsg] = useState("");

  const sendTest = async () => {
    if (!testTo.trim()) {
      setTestMsg("수신번호를 입력하세요.");
      return;
    }
    setTestStatus("sending");
    try {
      const axios = (await import("axios")).default;
      const res = await axios.post(`${apiAddr}/post/sendsms`, {
        pnum: testTo.trim(),
        replyNumber: replyNumber.trim(),
        hqCode: (localStorage.hq || "").trim(),
        name: "테스트",
        callsgn: "테스트차량",
        sort: "테스트",
        org: "테스트",
        sumnum: "1",
        rdvs: "",
        cntct: "",
        datakind: "test",
        dsid: sessionStorage.ondsid || "",
        seqnum: 0,
        rgid: "",
      });
      if (res.data.result === "success") {
        setTestStatus("done");
        setTestMsg("전송 완료");
      } else {
        setTestStatus("error");
        setTestMsg(res.data.message || "실패");
      }
    } catch (e) {
      setTestStatus("error");
      setTestMsg(e.message);
    }
  };

  return (
    <div className={cls.msgPanel}>
      <span style={{ fontWeight: 700, whiteSpace: "nowrap" }}>
        선탑자 전달사항
      </span>
      <textarea
        className={cls.msgTextarea}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="재난 개요, 주의사항 등"
      />
      <span style={{ fontWeight: 700, whiteSpace: "nowrap" }}>회신번호</span>
      <input
        value={replyNumber}
        onChange={(e) => setReplyNumber(fmtPhone(e.target.value))}
        style={{
          width: "9em",
          padding: "3px 6px",
          borderRadius: 4,
          border: "1px solid #ccc",
        }}
        placeholder="033-249-5664"
      />
      <button
        type="button"
        className={cls.btnAction}
        style={{ background: showTest ? "#ffa726" : "#42a5f5", color: "#fff", border: "none" }}
        onClick={() => setShowTest((v) => !v)}
      >
        문자전송 테스트
      </button>
      {showTest && (
        <>
          <input
            value={testTo}
            onChange={(e) => setTestTo(fmtPhone(e.target.value))}
            placeholder="010-0000-0000"
            style={{ width: "9em", padding: "3px 6px", borderRadius: 4 }}
          />
          <button type="button" className={cls.btnAction} onClick={sendTest}>
            {testStatus === "sending" ? "전송중" : "전송"}
          </button>
          {testMsg && (
            <span style={{ fontSize: "0.75rem", color: testStatus === "done" ? "#a5d6a7" : "#ef9a9a" }}>
              {testMsg}
            </span>
          )}
        </>
      )}
    </div>
  );
}
